'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Book = require('./Book');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Book).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Book/index.js
// module id = 1118
// module chunks = 1